import { combineReducers } from 'redux';

import auth from './auth';
import stream from './stream';
import likeTypes from './likeTypes';

export default combineReducers({
  auth,
  stream,
  likeTypes
});


// WEBPACK FOOTER //
// ./src/redux/modules/reducer.js